<template>
  <div class="menu" style="width: 100%; height: 100%; padding-left: 252px">
    <v-card style="height: 100%" elevation="0">
      <v-card-title style="padding-top: 18px; padding-bottom: 18px"> 应用菜单 </v-card-title>
      <v-toolbar flat>
        <v-btn-toggle v-model="btnValue" @change="btnGroupClick" dense group mandatory color="primary" class="ml-n2">
          <v-btn :value="bi.key" class="ml-2" v-for="(bi, index) in btnGroup" :key="index">
            <!-- <v-icon :color="bi.color">{{ bi.icon }}</v-icon> -->
            {{ bi.val }}
          </v-btn>
        </v-btn-toggle>
        <v-spacer />
        <div style="width: 300px">
          <v-text-field v-model="search" placeholder="菜单名称/标识" class="pt-5" append-icon="mdi-magnify" outlined dense flat clearable></v-text-field>
        </div>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text class="pa-0" style="height: calc(100% - 117px)">
        <v-row class="height_100">
          <v-col md="12" class="px-7">
            <v-card v-if="listData.length > 0" class="height_100" elevation="0">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left" style="width: 320px">名称</th>
                      <th class="text-left">图标</th>
                      <th class="text-left">键值</th>
                      <th class="text-left">路径</th>
                      <th class="text-left" style="width: 118px">操作</th>
                    </tr>
                  </thead>
                </template>
              </v-simple-table>
              <v-treeview :items="desserts" hoverable activatable :search="search" :filter="filter">
                <template v-slot:prepend="{ item }" style="width: 320px">
                  <v-icon :color="item.type | dict('0:purple/1:primary/2:accent/3:secondary/4:red')"> mdi-{{ item.type | dict("0:television-guide/1:collage/2:ballot-outline/3:card/4:tag-multiple-outline") }} </v-icon>
                  {{ item.name }}
                </template>
                <template v-slot:label="{ item }">
                  <v-row class="text-left pr-6">
                    <v-col class="text-overflow">{{ item.icon }}</v-col>
                    <v-col class="text-overflow">{{ item.nkey }}</v-col>
                    <v-col class="text-overflow">{{ item.path }}</v-col>
                  </v-row>
                </template>
                <template v-slot:append="{ item }">
                  <v-btn icon elevation="0" @click="add(item)"><v-icon size="20" color="green">mdi-plus</v-icon></v-btn>
                  <v-btn icon elevation="0" @click="edit(item)"><v-icon size="20" color="blue">mdi-playlist-edit</v-icon></v-btn>
                  <v-btn icon elevation="0" @click="del(item.id)"><v-icon size="20" color="red">mdi-delete-outline</v-icon></v-btn>
                </template>
              </v-treeview>
            </v-card>
            <div v-else>
              <v-img class="mx-auto mt-16" max-width="220" :src="require('@/assets/img/noData.png')"></v-img>
              <p class="text-center grey--text mt-6">
                该应用暂无菜单信息
                <br />
                点击 <a @click="init" style="text-decoration: underline">初始化菜单</a>
              </p>
            </div>
          </v-col>
          <!-- 新增弹窗 -->
          <v-dialog v-model="dialog" persistent no-click-animation scrollable max-width="505px">
            <v-card class="height_100" tile elevation="0">
              <v-card-title>
                菜单<v-spacer />
                <v-btn class="mx-0" icon @click="close"><v-icon>mdi-close</v-icon></v-btn>
              </v-card-title>
              <v-divider />
              <v-card-text class="pa-0 pt-3">
                <v-form ref="entity" :model="entity" class="px-4">
                  <wtk-select v-model="entity.type" label="类型" :rules="[(v) => !!v || '类型不能为空!']" list="0:平台/1:应用/2:菜单/3:按钮/4:标签" dense outlined></wtk-select>
                  <v-text-field v-model="entity.name" :rules="[(v) => !!v || '菜单名称不能为空!']" label="菜单名称" dense outlined class="mt-1"></v-text-field>
                  <v-text-field v-model="entity.icon" :rules="[(v) => !!v || '菜单图标不能为空!']" label="菜单图标" dense outlined></v-text-field>
                  <v-text-field v-model="entity.path" :rules="[(v) => !!v || '访问路径不能为空!']" label="访问路径" dense outlined></v-text-field>
                  <v-text-field v-model="entity.ordering" :rules="[(v) => !!v || '排序不能为空!']" type="number" label="排序" dense outlined></v-text-field>
                  <v-text-field v-model="entity.nkey" :rules="[(v) => !!v || '键值不能为空!']" label="键值" dense outlined></v-text-field>
                  <v-textarea label="说明" dense outlined v-model="entity.note" :rules="[(v) => !!v || '说明不能为空!']" auto-grow></v-textarea>
                </v-form>
              </v-card-text>
              <v-divider />
              <v-card-actions>
                <v-spacer />
                <v-btn @click="close" text elevation="0"> 取消 </v-btn>
                <v-btn color="primary" text @click="save" elevation="0"> 保存 </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import Request from "@/commons/request";
import Message from "@/components/message";
import Storage from "@/commons/storage";
import wtkSelect from "@/components/dictionary/WtkSelect";
export default {
  components: { wtkSelect },
  data: () => ({
    loading: true,
    desserts: [],
    listData: [],
    btnGroup: [
      { key: "A", val: "全部", icon: "mdi-apps", color: "deep-purple" },
      { key: "0", val: "平台", icon: "mdi-television-guide", color: "purple" },
      { key: "1", val: "应用", icon: "mdi-collage", color: "primary" },
      { key: "2", val: "菜单", icon: "mdi-ballot-outline", color: "accent" },
      { key: "3", val: "按钮", icon: "mdi-card", color: "secondary" },
      { key: "4", val: "标签", icon: "mdi-tag-multiple-outline", color: "red" },
    ],
    btnValue: "A",
    valid: true,
    queryParams: { codex: {} },
    entity: {},
    dialog: false,
    search: null,
    caseSensitive: false,
  }),
  computed: {
    filter() {
      return this.caseSensitive ? (item, search, textKey) => item[textKey].indexOf(search) > -1 : undefined;
    },
  },
  mounted() {
    this.menuQuery();
  },
  watch: {
    $route(to, from) {
      to.query.aid && to.query.aid != from.query.aid && this.menuQuery();
    },
  },
  methods: {
    //新增菜单树
    add(item) {
      if (this.entity.id) {
        this.entity = {};
        this.$refs.entity.reset();
      }
      this.entity.pid = item.id;
      this.dialog = true;
    },
    //编辑菜单树
    edit(item) {
      this.dialog = true;
      this.entity = Object.assign({}, item);
    },
    del(id) {
      Message.confirm({ title: "确认删除", text: "删除后将无法恢复，请谨慎操作！" }, (result) => {
        result &&
          Request.getForm("/rbac/perm/delete", { id: id }).then((res) => {
            if (res.meta.success) {
              Message.toast("删除成功", { color: "success" });
              this.menuQuery();
            } else {
              Message.toast(res.meta.message, { color: "warning" });
            }
          });
      });
    },
    //菜单树
    menuQuery() {
      this.queryParams.codex.aid = this.$route.query.aid;
      Request.postJson("/rbac/perm/list", this.queryParams).then((res) => {
        this.listData = res.data;
        this.desserts = this.getJsonTree(res.data, "0");
      });
    },
    //递归方法 生成 json tree 数据
    getJsonTree(data, pid) {
      var itemArr = [];
      for (var i = 0; i < data.length; i++) {
        var node = data[i];
        if (node.pid == pid) {
          var newNode = {};
          newNode.id = node.id;
          newNode.name = node.name;
          newNode.note = node.note;
          newNode.nkey = node.nkey;
          newNode.icon = node.icon;
          newNode.path = node.path;
          newNode.ordering = node.ordering;
          newNode.gid = node.gid;
          newNode.pid = node.pid;
          newNode.remark = node.remark;
          newNode.type = node.type;
          newNode.operateTime = node.operateTime;
          newNode.children = this.getJsonTree(data, node.id);
          itemArr.push(newNode);
        }
      }
      return itemArr;
    },
    //顶部tab切换检索
    btnGroupClick() {
      this.queryParams.codex.type = this.btnValue == "A" ? null : this.btnValue;
      let data = this.btnValue == "A" ? this.listData : this.listData.filter((item) => item.type.indexOf(this.btnValue) >= 0);
      this.desserts = data.length > 0 ? this.getJsonTree(data, data[0].pid) : [];
    },
    save() {
      if (this.$refs.entity.validate()) {
        Message.loading.show();
        this.entity.aid = this.$route.query.aid;
        this.entity.operator = Storage.get("_wit_acis_users").username;
        Request.postJson("/rbac/perm/save", this.entity).then((res) => {
          Message.loading.hide();
          if (res.meta.success && res.data) {
            Message.toast("保存成功！", { color: "success" });
            this.close();
            this.menuQuery();
          } else {
            Message.toast(res.meta.message, { color: "error" });
          }
        });
      }
    },
    //菜单初始化
    init() {
      Message.confirm({ title: "菜单初始化确认", text: "菜单初始化后系统将自动生成一级菜单?" }, (result) => {
        result &&
          Request.postForm("/rbac/perm/init", { aid: this.$route.query.aid }).then((res) => {
            Message.loading.hide();
            if (res.meta.success) {
              this.menuQuery();
              Message.toast("菜单初始化成功！", { color: "success" });
            } else {
              Message.toast(res.meta.message, { color: "error" });
            }
          });
      });
    },
    //关闭弹窗
    close() {
      this.entity = {};
      this.$refs.entity.reset();
      this.dialog = false;
    },
  },
};
</script>
<style lang="scss">
.menu .v-treeview-node__root {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.menu .v-treeview-node__prepend {
  width: 292px;
}
@for $i from 1 through 10 {
  .menu .v-treeview-node__level:nth-child(n + #{$i}) + button ~ .v-treeview-node__content .v-treeview-node__prepend {
    width: 292px - 24px * $i;
  }
  .menu .v-treeview-node__level:nth-child(n + #{$i + 1}) + div.v-treeview-node__content .v-treeview-node__prepend {
    width: 292px - 24px * $i;
  }
}
</style>